'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ELLIPSIS = exports.appBarStyles = exports.hasSecondaryNavTallClass = exports.hasSecondaryNavClass = exports.ARROW_ICON_PADDING = exports.MAX_TAB_CONTENT_WIDTH_MAP = exports.TAB_PADDING_MAP = exports.MAX_TAB_WIDTH = exports.MAX_TABS_LIST_WIDTH = exports.NAV_INSET_MAP = exports.BREAKPOINTS_MAP = exports.BREAKPOINT_KEY_LIST = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getScreenSizeKey = getScreenSizeKey;

var _createBreakpoints = require('@material-ui/core/styles/createBreakpoints');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// [ 'XS', 'SM', 'MD', 'LG', 'XL' ]
var BREAKPOINT_KEY_LIST = exports.BREAKPOINT_KEY_LIST = _createBreakpoints.keys.map(function (key) {
  return key.toUpperCase();
});

var BREAKPOINTS_MAP = exports.BREAKPOINTS_MAP = {
  XS: 360,
  SM: 600,
  MD: 960,
  LG: 1280,
  XL: 1920
};

var NAV_INSET_MAP = exports.NAV_INSET_MAP = {
  XS: 72,
  SM: 72,
  MD: 80,
  LG: 80,
  XL: 80
};

var MAX_NAV_WIDTH = BREAKPOINTS_MAP.MD;

var MAX_TABS_LIST_WIDTH = exports.MAX_TABS_LIST_WIDTH = MAX_NAV_WIDTH - NAV_INSET_MAP.MD;

var MAX_TAB_WIDTH = exports.MAX_TAB_WIDTH = 264;

var TAB_PADDING_SM = 12;
var TAB_PADDING_LG = 24;

var TAB_PADDING_MAP = exports.TAB_PADDING_MAP = {
  XS: TAB_PADDING_SM,
  SM: TAB_PADDING_SM,
  MD: TAB_PADDING_LG,
  LG: TAB_PADDING_LG,
  XL: TAB_PADDING_LG
};

var MAX_TAB_CONTENT_WIDTH_MAP = exports.MAX_TAB_CONTENT_WIDTH_MAP = {
  XS: MAX_TAB_WIDTH - TAB_PADDING_MAP.XS * 2,
  SM: MAX_TAB_WIDTH - TAB_PADDING_MAP.SM * 2,
  MD: MAX_TAB_WIDTH - TAB_PADDING_MAP.MD * 2,
  LG: MAX_TAB_WIDTH - TAB_PADDING_MAP.LG * 2,
  XL: MAX_TAB_WIDTH - TAB_PADDING_MAP.XL * 2
};

var ARROW_ICON_PADDING = exports.ARROW_ICON_PADDING = 7;

var hasSecondaryNavClass = exports.hasSecondaryNavClass = 'hasSecondaryNav';
var hasSecondaryNavTallClass = exports.hasSecondaryNavTallClass = 'hasSecondaryNav--tall';
var appBarStyles = exports.appBarStyles = (0, _defineProperty3.default)({}, '.' + hasSecondaryNavClass + ' &', {
  paddingBottom: 48
});

/**
 * Returns first entry who's value is larger than the browsers width
 * @return {String}
 */
function getScreenSizeKey() {
  return BREAKPOINT_KEY_LIST.find(function (key) {
    return window.innerWidth < BREAKPOINTS_MAP[key];
  }) || BREAKPOINT_KEY_LIST[BREAKPOINT_KEY_LIST.length - 1];
}

var ELLIPSIS = exports.ELLIPSIS = '…';